/* Olfé homepage: gedrag van de hero-slider, shop per categorie, de productcarrousel en het uitzoomen
   van beelden. Kleine custom elements, geen framework. Stijl: assets/olfe-home.css. */
(function () {
  'use strict';

  if (window.OlfeHomeLoaded) return;
  window.OlfeHomeLoaded = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var noHover = window.matchMedia('(hover: none)');

  function define(name, ctor) {
    if (!window.customElements.get(name)) window.customElements.define(name, ctor);
  }

  /* ---------- Hero-slider ----------
     De voortgangsbalk van de actieve slide is een CSS-animatie; als die klaar is volgt de volgende slide.
     Pauzeren is dus de animatie stilzetten (hover, focus, uit beeld, tab verborgen). */
  class OlfeHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ohs-slide]'));
      this.texts = Array.prototype.slice.call(this.querySelectorAll('[data-ohs-text]'));
      this.bars = Array.prototype.slice.call(this.querySelectorAll('[data-ohs-bar]'));
      this.index = 0;
      this.holds = {};
      var self = this;
      function markReady() { self.classList.add('is-ready'); }
      if (this.slides.length < 2) {
        requestAnimationFrame(markReady);
        return;
      }

      this.bars.forEach(function (bar, i) {
        bar.addEventListener('click', this.go.bind(this, i));
        var fill = bar.querySelector('.ohs__bar-fill');
        if (fill) fill.addEventListener('animationend', this.next.bind(this));
      }, this);

      /* De slides lopen door, ook met de muis op de hero. Pauzeren kan met de knop naast de balken. */
      this.toggle = this.querySelector('[data-ohs-toggle]');
      if (this.toggle) {
        this.toggle.addEventListener('click', function () {
          var paused = !this.holds.user;
          this.hold('user', paused);
          this.classList.toggle('is-user-paused', paused);
          this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          this.toggle.setAttribute('aria-label', this.toggle.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
        }.bind(this));
      }
      this.addEventListener('focusin', function (event) { if (event.target.matches(':focus-visible')) this.hold('focus', true); }.bind(this));
      this.addEventListener('focusout', this.hold.bind(this, 'focus', false));
      document.addEventListener('visibilitychange', function () { this.hold('hidden', document.hidden); }.bind(this));
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          this.hold('offscreen', !entries[0].isIntersecting);
        }.bind(this), { threshold: 0.15 }).observe(this);
      }

      /* Vegen op een aanraakscherm */
      var startX = null;
      var startY = null;
      this.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      this.addEventListener('touchend', function (event) {
        if (startX === null) return;
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        this.go((this.index + (dx < 0 ? 1 : -1) + this.slides.length) % this.slides.length);
      }.bind(this), { passive: true });

      this.setTop = this.setTop.bind(this);
      this.setTop();
      window.addEventListener('resize', this.setTop);
      window.addEventListener('load', this.setTop);

      this.setAuto();
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', this.setAuto.bind(this));
      this.render();
      /* Eerst de beginstand laten tekenen, dan pas de langzame zoom starten. */
      requestAnimationFrame(function () { requestAnimationFrame(markReady); });
    }

    /* Hoeveel er boven de hero staat (de mededelingenbalk): de hero vult de rest van het scherm. */
    setTop() {
      var top = Math.max(0, Math.round(this.getBoundingClientRect().top + window.scrollY));
      this.style.setProperty('--ohs-top', top + 'px');
    }

    setAuto() {
      this.classList.toggle('is-auto', this.getAttribute('data-autoplay') !== 'false' && !reducedMotion.matches);
    }

    hold(reason, on) {
      this.holds[reason] = on;
      var paused = Object.keys(this.holds).some(function (key) { return this.holds[key]; }, this);
      this.classList.toggle('is-paused', paused);
    }

    next() {
      this.go((this.index + 1) % this.slides.length);
    }

    go(index) {
      if (index === this.index) {
        /* Zelfde slide: de balk opnieuw laten lopen. */
        var bar = this.bars[index];
        if (bar) { bar.classList.remove('is-active'); void bar.offsetWidth; }
      }
      this.index = index;
      this.render();
    }

    render() {
      var index = this.index;
      this.slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      this.texts.forEach(function (text, i) {
        text.classList.toggle('is-active', i === index);
        if (i === index) text.removeAttribute('aria-hidden'); else text.setAttribute('aria-hidden', 'true');
      });
      this.bars.forEach(function (bar, i) {
        bar.classList.toggle('is-done', i < index);
        bar.classList.toggle('is-active', i === index);
        bar.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
  }

  /* ---------- Shop per categorie ----------
     Muis of toetsenbord: de rij waar je op staat wordt actief. Aanraakscherm: de categorieën lichten
     om de beurt op zolang de sectie in beeld is; een tik gaat direct naar de collectie. */
  class OlfeCategoryHover extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-ocat-row]'));
      this.images = Array.prototype.slice.call(this.querySelectorAll('[data-ocat-image]'));
      this.index = 0;
      this.timer = null;
      this.visible = false;

      this.rows.forEach(function (row, i) {
        row.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') this.set(i); }.bind(this));
        row.addEventListener('focus', this.set.bind(this, i));
      }, this);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          this.visible = entries[0].isIntersecting;
          this.cycle();
        }.bind(this), { threshold: 0.35 }).observe(this);
      }
      if (noHover.addEventListener) noHover.addEventListener('change', this.cycle.bind(this));
      document.addEventListener('visibilitychange', this.cycle.bind(this));
    }

    set(index) {
      this.index = index;
      this.rows.forEach(function (row, i) { row.classList.toggle('is-active', i === index); });
      this.images.forEach(function (image, i) { image.classList.toggle('is-active', i === index); });
    }

    cycle() {
      window.clearInterval(this.timer);
      this.timer = null;
      var interval = Number(this.getAttribute('data-cycle')) * 1000;
      if (!interval || !this.visible || document.hidden || !noHover.matches || reducedMotion.matches || this.rows.length < 2) return;
      this.timer = window.setInterval(function () {
        this.set((this.index + 1) % this.rows.length);
      }.bind(this), interval);
    }
  }

  /* ---------- Shop per categorie op aanraakschermen: swipen ----------
     Gewoon horizontaal scrollen met scroll-snap. De rij staat er drie keer (kopie, origineel, kopie);
     staat de rij stil op een kopie, dan springt hij onzichtbaar naar dezelfde kaart in het midden, zodat
     je eindeloos door kunt swipen. De grootte van de kaarten volgt de scrollpositie (--d per kaart). */
  class OlfeCategorySwipe extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-ocs-track]');
      if (!this.track) return;
      this.originals = Array.prototype.slice.call(this.track.children);
      this.count = this.originals.length;
      this.cards = this.originals;
      this.copied = false;
      this.cardWidth = 0;
      this.trackWidth = 0;
      this.touching = false;
      this.frame = null;
      this.idle = null;

      this.paint = this.paint.bind(this);
      this.settle = this.settle.bind(this);
      this.measure = this.measure.bind(this);

      this.track.addEventListener('scroll', function () {
        if (!this.frame) this.frame = window.requestAnimationFrame(this.paint);
        this.queueSettle();
      }.bind(this), { passive: true });
      this.track.addEventListener('touchstart', function () { this.touching = true; }.bind(this), { passive: true });
      ['touchend', 'touchcancel'].forEach(function (type) {
        this.track.addEventListener(type, function () { this.touching = false; this.queueSettle(); }.bind(this), { passive: true });
      }, this);

      if ('ResizeObserver' in window) new ResizeObserver(this.measure).observe(this.track);
      else window.addEventListener('resize', this.measure);
      this.measure();

      /* Thema-editor: de kaart van het gekozen blok in het midden zetten. */
      var section = this.closest('.shopify-section');
      if (section) {
        section.addEventListener('shopify:block:select', function (event) {
          var id = event.detail && event.detail.blockId;
          this.originals.forEach(function (card, i) {
            if (card.getAttribute('data-block-id') === id) this.jump(this.copied ? this.count + i : i);
          }, this);
        }.bind(this));
      }
    }

    addCopies() {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      this.originals.forEach(function (card) {
        [before, after].forEach(function (target) {
          var copy = card.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('data-block-id');
          Array.prototype.forEach.call(copy.querySelectorAll('a'), function (link) { link.setAttribute('tabindex', '-1'); });
          target.appendChild(copy);
        });
      });
      this.track.insertBefore(before, this.track.firstChild);
      this.track.appendChild(after);
      this.cards = Array.prototype.slice.call(this.track.children);
      this.copied = true;
    }

    /* Komt de rij in de buurt van het scherm, dan alle kaartbeelden alvast laden en direct tekenen;
       zo verschijnt er bij het swipen (en bij de onzichtbare sprong) nooit een leeg vlak. */
    preload() {
      if (this.preloading) return;
      this.preloading = true;
      var load = function () {
        Array.prototype.forEach.call(this.track.querySelectorAll('img'), function (image) {
          image.decoding = 'sync';
          image.loading = 'eager';
        });
      }.bind(this);
      if (!('IntersectionObserver' in window)) { load(); return; }
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        load();
      }, { rootMargin: '100% 0px' });
      observer.observe(this);
    }

    /* Door de zijruimte van de rij staat kaart i in het midden bij scrollLeft = i x kaartbreedte.
       De kopieën komen er pas bij als de rij zichtbaar is; op desktop (rij verborgen) gebeurt er niets. */
    measure() {
      var trackWidth = this.track.clientWidth;
      var cardWidth = this.cards.length ? this.cards[0].getBoundingClientRect().width : 0;
      if (!trackWidth || !cardWidth) return;
      if (trackWidth === this.trackWidth && cardWidth === this.cardWidth) return;
      var index = this.cardWidth ? this.current() : 0;
      if (!this.copied && this.count > 1) {
        this.addCopies();
        index += this.count;
      }
      this.preload();
      this.trackWidth = trackWidth;
      this.cardWidth = cardWidth;
      this.jump(index);
    }

    current() {
      return Math.round(this.track.scrollLeft / this.cardWidth);
    }

    jump(index) {
      this.track.scrollLeft = index * this.cardWidth;
      this.paint();
    }

    paint() {
      this.frame = null;
      if (!this.cardWidth) return;
      var position = this.track.scrollLeft / this.cardWidth;
      this.cards.forEach(function (card, i) {
        var distance = Math.min(1, Math.abs(i - position)).toFixed(3);
        if (card.olfeDistance === distance) return;
        card.olfeDistance = distance;
        card.style.setProperty('--d', distance);
      });
    }

    queueSettle() {
      window.clearTimeout(this.idle);
      this.idle = window.setTimeout(this.settle, 140);
    }

    settle() {
      if (this.touching || !this.copied || !this.cardWidth) return;
      var index = this.current();
      if (Math.abs(this.track.scrollLeft - index * this.cardWidth) > 2) return;
      if (index < this.count) this.jump(index + this.count);
      else if (index >= this.count * 2) this.jump(index - this.count);
    }
  }

  /* ---------- Productcarrousel met voortgangslijn ---------- */
  class OlfeCarousel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-ocar-track]');
      this.thumb = this.querySelector('[data-ocar-thumb]');
      this.prev = this.querySelector('[data-ocar-prev]');
      this.nextButton = this.querySelector('[data-ocar-next]');
      if (!this.track) return;

      this.update = this.update.bind(this);
      this.paint = this.paint.bind(this);
      this.frame = null;
      this.track.addEventListener('scroll', function () {
        if (!this.frame) this.frame = window.requestAnimationFrame(this.paint);
      }.bind(this), { passive: true });
      window.addEventListener('resize', this.update);
      if ('ResizeObserver' in window) new ResizeObserver(this.update).observe(this.track);
      if (this.prev) this.prev.addEventListener('click', this.step.bind(this, -1));
      if (this.nextButton) this.nextButton.addEventListener('click', this.step.bind(this, 1));
      /* Kaarten kunnen later verdwijnen (verborgen kleuren) of beelden laden: lijn daarna bijwerken. */
      window.addEventListener('load', function () { window.setTimeout(this.update, 300); }.bind(this));
      this.update();
    }

    step(direction) {
      var card = this.track.firstElementChild;
      if (!card) return;
      var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }

    /* Maten opnieuw bepalen: bij de start, als de rij van formaat verandert en na het laden. */
    update() {
      var track = this.track;
      this.max = track.scrollWidth - track.clientWidth;
      var ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      this.thumbWidth = Math.max(12, Math.min(100, ratio * 100));
      this.barWidth = 0;
      if (this.thumb) {
        var bar = this.thumb.parentElement;
        bar.hidden = this.max <= 1;
        this.thumb.style.width = this.thumbWidth + '%';
        this.barWidth = bar.clientWidth;
      }
      this.paint();
    }

    /* Tijdens het scrollen: één keer per beeldje, alleen de scrollpositie lezen en de lijn verschuiven
       met transform (geen transition), zodat de lijn de vinger precies volgt. */
    paint() {
      this.frame = null;
      var left = this.track.scrollLeft;
      var max = this.max;
      var progress = max > 0 ? Math.min(1, Math.max(0, left / max)) : 0;
      if (this.thumb) {
        var travel = this.barWidth * (100 - this.thumbWidth) / 100;
        this.thumb.style.transform = 'translate3d(' + (progress * travel).toFixed(2) + 'px, 0, 0)';
      }
      var atStart = left <= 1;
      var atEnd = max <= 1 || left >= max - 1;
      if (this.prev && this.prev.disabled !== atStart) this.prev.disabled = atStart;
      if (this.nextButton && this.nextButton.disabled !== atEnd) this.nextButton.disabled = atEnd;
    }
  }

  define('olfe-hero-slider', OlfeHeroSlider);
  define('olfe-category-hover', OlfeCategoryHover);
  define('olfe-category-swipe', OlfeCategorySwipe);
  define('olfe-carousel', OlfeCarousel);

  /* ---------- Beelden die uitzoomen zodra ze in beeld komen ----------
     De waarnemer kijkt naar het kader om het beeld (het beeld zelf is vergroot) en zet de klasse op het beeld. */
  function bootZoom() {
    var items = document.querySelectorAll('[data-oh-zoom]:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        Array.prototype.forEach.call(entry.target.querySelectorAll('[data-oh-zoom]'), function (el) { el.classList.add('is-in'); });
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2 });
    var frames = [];
    Array.prototype.forEach.call(items, function (el) {
      var frame = el.closest('[data-oh-zoom-frame]') || el.parentElement;
      if (frames.indexOf(frame) === -1) { frames.push(frame); observer.observe(frame); }
    });
  }

  /* ---------- Sfeerfoto op een productkaart ----------
     De sfeerfoto hoort bij de kleur waarmee de kaart opent. Wijst of tikt de bezoeker een andere kleur aan,
     dan toont het thema de studiofoto van die kleur en gaat de sfeerfoto zolang opzij. */
  function bootMood() {
    Array.prototype.forEach.call(document.querySelectorAll('.olfe-card-mood'), function (mood) {
      var card = mood.closest('.card');
      if (!card || card.olfeMoodSwatch !== undefined) return;
      card.olfeMoodSwatch = card.querySelector('.swatch-hover-wrap.swatch-active') || card.querySelector('.swatch-hover-wrap') || null;
    });
  }

  function moodCard(event) {
    var swatch = event.target.closest ? event.target.closest('.swatch-hover-wrap') : null;
    var card = swatch ? swatch.closest('.card') : null;
    if (!card || !card.olfeMoodSwatch) return null;
    return { card: card, swatch: swatch };
  }

  document.addEventListener('mouseover', function (event) {
    var hit = moodCard(event);
    if (hit) hit.card.classList.toggle('is-mood-off', hit.swatch !== hit.card.olfeMoodSwatch);
  });
  document.addEventListener('mouseout', function (event) {
    var hit = moodCard(event);
    if (!hit || hit.swatch.contains(event.relatedTarget) || noHover.matches) return;
    hit.card.classList.remove('is-mood-off');
  });
  document.addEventListener('click', function (event) {
    var hit = moodCard(event);
    if (hit && noHover.matches) hit.card.classList.toggle('is-mood-off', hit.swatch !== hit.card.olfeMoodSwatch);
  }, true);

  function boot() {
    bootZoom();
    bootMood();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
